import axios from 'axios';
import apiConfig from '../shared/config/api.config';

export default function uploadDocumentRequest(hotelId, data) {
  const { file, type, documentCode, checkinGuestId, signer, extractData = false, vectorImage } = data;

  const {
    host,
    URIs: { uploadDocument },
  } = apiConfig;

  const uri = `${host}${uploadDocument}`.replace(':hotelId', hotelId);

  const formData = new FormData();
  formData.append('file', file);
  formData.append('type', type);
  if (documentCode) formData.append('documentCode', documentCode);
  if (checkinGuestId) formData.append('idCheckinGuest', checkinGuestId);
  if (extractData) formData.append('extractData', extractData);
  if (signer) formData.append('signer', signer);
  if (vectorImage) formData.append('vectorImage', vectorImage);

  // headers: formData.getHeaders(),
  return axios.post(uri, formData).then(res => {
    return res.data;
  });
}
